// extracted by mini-css-extract-plugin
module.exports = {"textButton":"_1Lh8u","danger":"_3Cg1V"};